import { ACTION_RELAX } from "../../tools/EyeActions";

/**
 * Shared setup logic for all avatar components.
 * Each avatar has different pupilOffsets but identical computation logic.
 */
export function getAvatarState(props, pupilOffsets) {
    const { eyeAction, size, visualHint } = props;
    const offset = pupilOffsets[eyeAction] || { x: 0, y: 0 };
    const isRelax = eyeAction === ACTION_RELAX;

    const padding = 40;
    let containerSize = size.width > size.height ? size.height - padding : size.width - padding;
    containerSize = Math.min(containerSize, 400);

    const isBlink = visualHint === 'blink';
    const pulseClass = visualHint && !isBlink ? `avatar-visualHint-${visualHint}` : '';

    return { offset, isRelax, containerSize, isBlink, pulseClass };
}
